import {api} from './APIMiddlewares'
import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'

export interface PaginationQuery {
  limit?: number
  offset?: number
  status?: string
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
}

export async function getOpenJobPosts() {
  const {token, tenantId} = setupAxios()
  return await api.get(
    `/job-post?status=OPEN&limit=100&offset=0`,
    token,
    tenantId,
    false
  )
}

export async function getJobPosts(params: Record<string, any> = {}) {
  const {token, tenantId} = setupAxios()
  const usp = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') usp.set(k, String(v))
  })
  const qs = usp.toString() ? `?${usp.toString()}` : ''
  return await api.get(`/job-post${qs}`, token, tenantId, false)
}

export async function getJobPostById(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/job-post/${id}`, token, tenantId, false)
}

export async function getPublicJobPostById(id: string) {
  const response = await fetch(`${API_BASE_URL}/application-form/job/${encodeURIComponent(id)}`)
  return await response.json()
}

export async function createJobPost(payload: any) {
  const {token, tenantId} = setupAxios()
  return await api.post(
    `/job-post`,
    token,
    tenantId,
    { body: JSON.stringify(payload) },
    false
  )
}

export async function getJobApplications(jobId: string, query: PaginationQuery = {}) {
  const {token, tenantId} = setupAxios()
  const params = new URLSearchParams()
  if (query.status) params.set('status', query.status)
  if (query.limit !== undefined) params.set('limit', String(query.limit))
  if (query.offset !== undefined) params.set('offset', String(query.offset))
  if (query.sortBy) params.set('sortBy', query.sortBy)
  if (query.sortOrder) params.set('sortOrder', query.sortOrder)
  const qs = params.toString() ? `?${params.toString()}` : ''
  return await api.get(
    `/hiring/job-applications/job/${jobId}${qs}`,
    token,
    tenantId,
    false
  )
}

export async function approveJobPost(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.patch(`/job-post/${id}/approve`, token, tenantId, { body: JSON.stringify({}) }, false)
}

export async function rejectJobPost(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.patch(`/job-post/${id}/reject`, token, tenantId, { body: JSON.stringify({}) }, false)
}

export async function closeJobPost(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.patch(`/job-post/${id}/close`, token, tenantId, { body: JSON.stringify({}) }, false)
}

export async function getApplicationById(id: string) {
  const {token, tenantId} = setupAxios()
  return await api.get(`/hiring/job-applications/${id}`, token, tenantId, false)
}

export async function updateApplication(id: string, payload: any) {
  const {token, tenantId} = setupAxios()
  return await api.put(`/hiring/job-applications/${id}`, token, tenantId, { body: JSON.stringify(payload) }, true)
}

export async function publicUploadResume(formData: FormData) {
  // public endpoint: do not send auth headers/content-type
  return await fetch(`${API_BASE_URL}/application-form/upload-resume`, {
    method: 'POST',
    body: formData,
  }).then((r) => r.json())
}

export async function publicSubmitApplication(payload: any) {
  return await fetch(`${API_BASE_URL}/application-form/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then((r) => r.json())
}


